import React from "react";
import FeedPage from "./FeedPage";
import FollowingRecentStrip from "../components/feed/FollowingRecentStrip";
import { useAuth } from "../context/AuthContext";

// MyFeedPage — the "Following only" feed at `/feed`. Renders the
// FollowingRecentStrip header (last 48h of follows) above the standard
// FeedPage chrome with `initialSource='following'` seeded.
//
// The strip self-hides for logged-out users and for logged-in users
// with no recent follow activity, so anonymous /feed traffic gets the
// same experience as /.
const MyFeedPage = () => {
  const { user } = useAuth();
  return (
    <>
      <FollowingRecentStrip user={user} />
      <FeedPage initialSource="following" />
    </>
  );
};

export default MyFeedPage;
